<template >
    <div>
        <v-tabs v-model="tab" background-color="#006699" center-active dark>
            <v-tab v-for="item in items" :key="item">
                {{ item }}
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card-text>
                    <v-row>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].nome" label="Nome do estudante" disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].sexo" label="Gênero" disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].datanascimento" label="Data de Nascimento" disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].datanascimento" label="Data de Nascimento" disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].provincia" label="Natural de:" disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].bi" label="BI:" disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].nomedopai" label="Filho de :" disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].nomedamae" label="e De :" disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].telefone" label="Contacto :" disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].idMatricula" label="Matricula:" disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="estudanteDados[0].instituicao" label="Instituição Inscrito:" disabled></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-tab-item>
            <v-tab-item>
                <v-card-text>
                    <v-row>
                        <v-col md="12"><strong> {{ titulo }}</strong></v-col>
                        <v-col md="12">
                            <v-card>
                                <v-card-text>
                                    <v-data-table :headers="headers" :items="estudanteDados">

                                        <template v-slot:item.estado="{ item }">
                                            <span v-if="item.status_2 == 2" style="color:#a39127">Matrícula Trancada</span>
                                            <span v-else style="color:green">Activo(a)</span>
                                        </template>

                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>
<script>

export default {
    name: 'tableDadosAcademicos',
    props: ['estudanteDados'],
    data: () => ({
        tab: null,
        items: ['Dados Pessoais','Dados académicos'],
        headers: [
            { text: 'Curso - Inscrito ', value: 'descricao_curso' },
            { text: 'Classes( Feitas )', value: 'classe' },
            { text: 'Turma', value: 'descricao_turma' },
            { text: 'Ano Lectivo', value: 'anoLectivo' },
            { text: 'Aprov.', value: 'resultado' },
            { text: 'Estado', value: 'estado' }
        ]
    })
}
</script>
<style>
._info_pessoais_pink {
    padding: 2px;
    color:white !important;
    margin-bottom: 3px;
}

._info_descricao_grey {
    margin-bottom: 3px;
}

</style>